import React from "react";

/**
 * BookFreely logo mark — the existing brand icon (calendar outline with a blue
 * check). Ink/slate stroke adapts to theme via currentColor; the check stays
 * brand blue. Small, clean, never stretched.
 */
export default function BrandMark({ size = 30, className = "", withGlow = false }) {
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        color: "var(--gf-text)",
        filter: withGlow ? "drop-shadow(0 2px 6px rgba(37,99,235,0.28))" : "none",
      }}
      aria-hidden="true"
      data-testid="brand-mark"
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* calendar top tabs */}
        <path d="M8 2.5v3M16 2.5v3" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
        {/* calendar body */}
        <rect x="3.25" y="4.75" width="17.5" height="16.5" rx="4.2" stroke="currentColor" strokeWidth="2.1" />
        {/* check — monochrome, matches wordmark */}
        <path d="M8 13.3l2.9 2.9L16.4 10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}
